import { getMutableComponentProps } from "./utils";
import { isAccessPreqinProEnabled, isPermissionsEnabled, isPreqinClientEnabled } from "hooks/use-tenant-settings";
export const removePreqinDefaultGroup = (componentProps, allDependencies, originalComponentProps) => {
    if (!isPermissionsEnabled() || !(isPreqinClientEnabled() && isAccessPreqinProEnabled())) {
        return componentProps;
    }
    const { switched } = allDependencies, mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    const gridSwitcher = mutableComponentProps?.gridSwitcher;
    const columns = (switched && gridSwitcher?.columnsTemplate ? gridSwitcher.columnsTemplate : mutableComponentProps.columnsTemplate)?.columns;
    if (!columns) {
        return mutableComponentProps;
    }
    columns.forEach((col) => {
        const colDef = col;
        if (colDef.rowGroup) {
            colDef.rowGroup = false;
        }
    });
    return mutableComponentProps;
};
